import template from './employee_view_document_component.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeViewDocumentComponentViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.employee_id = ko.observable();
		this.employee = ko.observable(null);
		this.logged_in_employee_id = Utils.get_local_storage_nullable('employee_id');
		this.employee_documents = ko.observableArray();
		this.document_types = ko.observableArray();
		this.access_roles = ko.observableArray();

		if (bindings.employee && ko.isObservable(bindings.employee))
			bindings.employee.subscribe((nv) => {
				if (nv)
				{
					this.employee(nv);
					this.updateData();
				}
			});

		if (bindings.employee_id && ko.isObservable(bindings.employee_id))
			bindings.employee_id.subscribe((nv) => { this.employee_id(nv); });

		this.save_document = this.save_document.bind(this);
		this.delete_document = this.delete_document.bind(this);
	}

	async updateData()
	{
		await this.loadPage();
	};

	// this is only loaded once user rights passes
	async loadPage()
	{
		this.employee_id(this.employee().employee_id);
		this.document_types(await Grape.cache.fetch('EmployeeDocumentTypeLookup'));
		this.access_roles(await Grape.cache.fetch('AccessRoleLookup') || []);
		let res = await Grape.fetches.postJSON('/employee/get_documents', { 'employee_id': this.employee_id() });
		
		if (res.documents)
			this.employee_documents(res.documents);
		else
			this.employee_documents.removeAll();
		
		let validDateSpans = document.querySelectorAll(".view.valid_date[data-bind='text: valid_date']");
		let currentDate = new Date();
		validDateSpans.forEach((span) => {
			let validDateString = span.textContent.trim();
			let validDate = new Date(validDateString);
			
			if (currentDate > validDate)
				span.style.color = "red";

		});
		await Utils.refresh_data_visible_roles();
	};

	async save_document(v, e)
	{
		let data = ko.toJS(v);
		let row = $(e.currentTarget).parent().parent();
	
		if (data.viewing_roles_access == undefined || data.viewing_roles_access == '' || data.viewing_roles_access == null)
		{
			Grape.alerts.alert({type: 'error',message: tr('You cannot save a document without any access rights selected.'), title: tr('Error')});
			return;
		}
	
		if (!data.name || data.name == "")
			data.name = data.filename;
	
		data.valid_date = data.valid_date;
	
		if (data.valid_date == "")
			data.valid_date = null;
	
		data.viewing_roles_access = data.viewing_roles_access.toString();
	
		// Check if document already exists (editing mode)
		if (data.employee_document_id != null && data.employee_document_id !== '')
		{
			let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Do you want to bulk update the roles for this document type? Doing that will update the viewing roles of the documents that are already uploaded under this category.')});
			
			if (!response)
				return;
				
			data.bulk_update_viewing_roles = true;
		}
	
		// edit
		let res = await Grape.fetches.postJSON('/employee/save_employee_document/edit', data);
		if (res.status == 'OK')
		{
			Grape.alerts.alert({ type: 'success', message: tr('Successfully saved document.'), title: tr('Success', 'Success') });
			this.updateData();
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error')});
	
		// post json
		row.find('.edit').hide();
		row.find('.view').show();
	};

	cancel_edit_document(v, e)
	{
		this.updateData();
		let row = $(e.currentTarget).parent().parent();
		row.find('.edit').hide();
		row.find('.view').show();
	}


	async delete_document(v, e)
	{
		let data = ko.toJS(v);
		let row = $(e.currentTarget).parent().parent();

		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to remove this document?')});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/employee/delete_document', data);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully deleted entry.'), title: tr('Success') });
				this.updateData();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
		}

		// post json
		row.find('.edit').hide();
		row.find('.view').show();
	};

	show_documents_help()
	{
		Grape.dialog.open('DocumentsHelp', { employee_id: this.logged_in_employee_id });
	};

	async add_document(v, e)
	{
		let data = ko.toJS(v);
		await Grape.dialog.open('EmployeeUploadDocument', { employee_id : this.employee_id(), employee_document_type_id: data.employee_document_type_id});
		this.updateData();
	};

	async add_document_without_known_type()
	{
		await Grape.dialog.open('EmployeeUploadDocument', { employee_id: this.employee_id() });
		this.updateData();
	};

	download_document(v, e)
	{
		let data = ko.toJS(v);
		window.open(data.filename_link + '?download=yes', '_blank');
	};

	view_document(v, e)
	{
		let data = ko.toJS(v);
		window.open(data.filename_link, '_blank');
	};

	edit_document(v, e)
	{
		var row = $(e.currentTarget).parent().parent().parent();
		row.find('.edit').show();
		row.find('.view').hide();

		autocomplete(document.getElementById('txtDescription_component'),
			window.global_AutoComplete_Dictionary_Documents);
		autocomplete(document.getElementById('txtNote_component'),
			window.global_AutoComplete_Dictionary_Documents);
	};
}

export default {
	name: 'employee_view_document_component',
	viewModel: EmployeeViewDocumentComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/employee_view_document_component'
};
